/**
 * Application version information injected at build time
 */
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || "unknown";
export const BUILD_TIMESTAMP = import.meta.env.VITE_BUILD_TIMESTAMP || "unknown";
export const BUN_VERSION = import.meta.env.VITE_BUN_VERSION || "unknown";

/**
 * Get version info object
 */
export const versionInfo = {
  version: APP_VERSION,
  buildTimestamp: BUILD_TIMESTAMP,
  bunVersion: BUN_VERSION,
  string: `v${APP_VERSION} (bun ${BUN_VERSION}) @ ${BUILD_TIMESTAMP}`,
};
